import {Injectable} from '@angular/core';
import SessionState from 'app/core/states/session.state';

@Injectable({providedIn: 'root'})
export default class WeekFacade {
  /**
   * This helps update the state of the current week selected
   * @type {(weekName: string) => void}
   */
  public updateWeekName = this._state.updateWeekName.bind(this._state);
  /** This exposes the current selected week name as observable */
  public weekName$ = this._state.weekName$;
  /** This exposes the weeks in the session as observable */
  public weeks$ = this._state.weeks$;
	/** This exposes the weeks in the session as observable */
  public isoWeeks$ = this._state.isoWeeks$;

  public constructor(private readonly _state: SessionState) {
  }
}
